const noop = () => { };
const noopReturn = (v) => v;

export { noop, noopReturn };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@motionone/utils/dist/noop.es.js
// module id = L0zL
// module chunks = 0